var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagebar"},[(!_vm.satellite.expanded)?_c('Tabs',{attrs:{"tabs":_vm.tabs}}):_vm._e(),(_vm.satellite.available)?_c('TheSatelliteActions'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }